import { Component } from '@angular/core';
import { DatePipe } from '@angular/common';
import { ProtuneApiService } from '../../services/protune-api.service';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { AppSubscription, AuthService } from '../../services/auth.service';
import moment from 'moment';


@Component({
  selector: 'app-subscription-confirmation',
  standalone: true,
  imports: [DatePipe, RouterLink],
  templateUrl: './subscription-confirmation.component.html',
  styleUrl: './subscription-confirmation.component.scss'
})
export class SubscriptionConfirmationComponent {
  loading: boolean = true;
  hasError: boolean = false;
  subscription: AppSubscription;
  isAIEngineerSubscriptionExpired: boolean;
  hasAIEngineerSubscription: boolean = false;


  constructor(private protuneApiService: ProtuneApiService, private authService: AuthService, private route: ActivatedRoute) {
    const sessionId = this.route.snapshot.queryParamMap.get('sessionId');
    this.protuneApiService
      .updateUserSubscriptionWithSessionId(sessionId)
      .subscribe({
        next: (subscription) => {
          this.subscription = subscription;

          if (this.subscription.aiEngineerSubscriptionExpiration != null) {
            this.isAIEngineerSubscriptionExpired = moment().isAfter(this.subscription.aiEngineerSubscriptionExpiration);
            this.hasAIEngineerSubscription = true;
          }

          this.authService
            .refreshToken()
            .subscribe({
              next: () => {
                this.loading = false;
              }
            });
        },
        error: () => {
          this.loading = false;
          this.hasError = true;
        }
      });
  }
}
